import CommonHeader from './CommonHeader';
import CommonFooter from './CommonFooter';

export default function RedesignPageLayout({ children, hero, isHome, footer = true }) {
    return (
        <div className="redesign-page">
            <CommonHeader />
            <main>
                {hero}
                <div className={`redesign-container${hero ? ' redesign-container--below-hero' : ''}`}>
                    {children}
                </div>
            </main>
            {footer ? <CommonFooter isHome={isHome} /> : null}
        </div>
    );
}
